// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"613c0095","560":"df9c2611","586":"08bc984c","642":"1483add6","782":"22f1fc7c","788":"ee10fcd7","873":"665faa69"}[chunkId] + ".chunk.js";
};